import config from '@project/config';

const baseUrl = `${config.apiUrl}`;

export default {
  getStats: () => `${baseUrl}/general_informations`,
};
